var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.isPc)?_c('my-pc-footer'):_c('my-mobile-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }